import { render, staticRenderFns } from "./receivingAddress.vue?vue&type=template&id=5201c283&scoped=true"
import script from "./receivingAddress.vue?vue&type=script&lang=js"
export * from "./receivingAddress.vue?vue&type=script&lang=js"
import style0 from "./receivingAddress.vue?vue&type=style&index=0&id=5201c283&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5201c283",
  null
  
)

export default component.exports